<!-- ./Partners -->
<section class="partners mt-5n">
  <div class="container py-0">
    <div class="card shadow-lg">
      <div class="card-body p-4">
        <dc-slider-logos></dc-slider-logos>
      </div>
    </div>
  </div>
</section>
